import { Config } from "../config";

/**
 * [HttpPostRequest description]
 * @param {[type]} route_name [description]
 * @param {[type]} body_raw   [description]
 */
export async function HttpPostRequest(route_name, body_raw) {
  try {
    let headers = new Headers({
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token_auth"),
    });

    const response = await fetch(Config.apiUrl + route_name, {
      method: "POST",
      headers,
      body: JSON.stringify(body_raw),
    });

    return await response;
  } catch (error) {}
}

/**
 * [HttpGetRequest description]
 * @param {[type]} route_name [description]
 */
export async function HttpGetRequest(route_name) {
  try {
    let headers = new Headers({
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token_auth"),
    });

    const response = await fetch(Config.apiUrl + route_name, {
      method: "GET",
      headers,
    });

    return await response;
  } catch (error) {}
}

/**
 * [HttpDeleteRequest description]
 * @param {[type]} route_name [description]
 */
export async function HttpDeleteRequest(route_name) {
  try {
    let headers = new Headers({
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token_auth"),
    });

    const response = await fetch(Config.apiUrl + route_name, {
      method: "DELETE",
      headers,
    });

    return await response;
  } catch (error) {}
}

/**
[HttpPutRequest description]
@param {[type]} route_name [description]
@param {[type]} body_raw   [description]
*/
export async function HttpPutRequest(route_name, body_raw) {
  try {
    let headers = new Headers({
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token_auth"),
    });

    const response = await fetch(Config.apiUrl + route_name, {
      method: "PUT",
      headers,
      body: JSON.stringify(body_raw),
    });
    return await response;
  } catch (error) {}
}

/**
 * [HttpPostRequest description]
 * @param {[type]} route_name [description]
 * @param {[type]} body_raw   [description]
 */
export async function HttpPostRequestAbortable(route_name, body_raw, signal) {
  try {
    let headers = new Headers({
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token_auth"),
    });

    const response = await fetch(Config.apiUrl + route_name, {
      method: "POST",
      headers,
      body: JSON.stringify(body_raw),
      signal,
    });

    return await response;
  } catch (error) {}
}
